import Image from 'next/legacy/image';
import { useTranslation } from '../../lib/i18n';
import {
  COLLECTION_DETAIL_LOGO_SIZE,
  calcImageProps,
  prismicLoader,
} from '../../lib/images';
import { CategoryDetail } from '../category/detail';
import { Body } from '../cms/body';
import Grid from '../common/grid';
import List from '../common/list';
import { Container } from '../layout/container';
import Layout from '../layout/layout';
import LightBoxContextProvider from '../lightbox-context';
import { Country } from '../wine/country';

const Title = ({ collection, className, headingClassName = '' }) => (
  <div className={className}>
    <div className='flex flex-col lg:px-6 6xl:px-0'>
      <h1 className={headingClassName}>{collection.title}</h1>
      {collection.attributes && <Country wine={collection} centered={false} />}
      {collection.lead && <p className='mt-3 font-bold'>{collection.lead}</p>}
    </div>
  </div>
);

export const Inner = ({ collection, items, preview }) => {
  const { t } = useTranslation();
  return (
    <Layout
      preview={preview}
      title={collection.seoTitle}
      description={collection.seoDescription}
      canonicalUrl={collection.canonical_link1?.url}
    >
      <div className='detail-offset mb-10 '>
        <style>
          {`:root {
      --edvin-title: ${collection.metadata['fg-color']};
      --edvin-background: ${collection.metadata['bg-color']};
    }`}
        </style>

        {collection.backgroundImageUrl ? (
          <div
            className={`mb-10 w-full bg-varBackground text-center lg:text-left`}
          >
            <div className={`mx-auto max-w-6xl`}>
              <div className='flex items-center'>
                <Title
                  collection={collection}
                  headingClassName='mb-3 text-black lg:text-6xl lg:text-varTitle'
                  className={`hidden max-w-1/2 pr-10 lg:block lg:text-left`}
                />
                <div className='relative h-60 flex-grow lg:h-96'>
                  <Image
                    loader={prismicLoader}
                    src={collection.backgroundImageUrl}
                    alt=''
                    layout='fill'
                    objectFit='cover'
                    objectPosition='center'
                    priority
                  />

                  {collection.logo && (
                    <div className='flex h-full items-center justify-center'>
                      <Image
                        loader={prismicLoader}
                        {...calcImageProps(
                          collection.logo,
                          COLLECTION_DETAIL_LOGO_SIZE,
                        )}
                      />
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        ) : (
          <></>
        )}

        <Container>
          <Title
            collection={collection}
            headingClassName={collection.backgroundImageUrl ? 'text-black' : ''}
            className={
              'mb-6 ' +
              (collection.backgroundImageUrl
                ? 'block lg:hidden lg:text-left'
                : 'ml-[5px] pt-6')
            }
          />
        </Container>

        <Body bodyElement={collection.body} />
        <div className='mt-10'>
          <Container>
            {collection.category === 'weingueter' &&
              collection.backgroundImageUrl && (
                <h2 className='py-10 text-center'>
                  {t('wine_from')} {collection.title}
                </h2>
              )}
            <List items={items} Wrapper={Grid} listName={collection.title} />
          </Container>
        </div>
      </div>
    </Layout>
  );
};

export const CollectionDetail = (props) => {
  if (props.isWineOnly) {
    return <CategoryDetail category={props.collection} {...props} />;
  }

  return (
    <LightBoxContextProvider>
      <Inner {...props} />
    </LightBoxContextProvider>
  );
};
